<template>
  <div id="posts">
    <div class="ui stackable grid">
      <div class="equal width row primary">
        <div class="column">
          <a href="https://blog.aragon.one/introducing-the-aragon-network-20b998e2caba" class="post first" target="_blank" rel="noopener noreferrer">
            <h2 class="ui inverted header">
              Introducing the Aragon Network
              <div class="sub header">Apr 14</div>
            </h2>
          </a>
        </div>
        <div class="column">
          <a href="https://blog.aragon.one/aragon-network-token-sale-terms-8998f63a3429" class="post second" target="_blank" rel="noopener noreferrer">
            <h2 class="ui inverted header">
              Aragon Network Token sale terms
              <div class="sub header">Apr 21</div>
            </h2>
          </a>
        </div>
      </div>
      <div class="equal width row">
        <div class="column">
          <a href="https://blog.aragon.one/announcing-the-aragon-network-token-sale-fe83fe36902c" class="post third" target="_blank" rel="noopener noreferrer">
            <h2 class="ui inverted header">
              Announcing the Aragon Network token sale
              <div class="sub header">Apr 20</div>
            </h2>
          </a>
        </div>
        <div class="column">
          <a href="https://blog.aragon.one/introducing-the-aragon-development-plan-857fbbe90779" class="post fourth" target="_blank" rel="noopener noreferrer">
            <h2 class="ui inverted header">
              Introducing the Aragon Development Plan
              <div class="sub header">Apr 24</div>
            </h2>
          </a>
        </div>
        <div class="column">
          <a href="https://blog.aragon.one/the-path-to-mainstream-decentralized-organizations-d95a89d3cac4" class="post fifth" target="_blank" rel="noopener noreferrer">
            <h2 class="ui inverted header">
              The path to mainstream decentralized organizations
              <div class="sub header">Apr 25</div>
            </h2>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'posts',
}
</script>

<style scoped>
#posts .column, #posts .grid, #posts .row {
  margin: 0 !important;
  padding: 0 !important;
}
#posts .primary .post {
  height: 312px;
}
.post {
  position: relative;
  display: block;
  width: 100%;
  min-height: 256px;
  box-shadow: inset 0 5px 10px black;
  background-color: rgba(0,0,0,0.5);
  transition: background-color 0.25s ease-in-out;
}
.post:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  z-index: -1;

  display: block;
  width: 100%;
  height: 100%;

  background-size: cover;
  background-position: center;
}
.post:hover {
  background-color: rgba(0,0,0,0.25);
}
.post.first:before {
  background-image: url('https://cdn-images-1.medium.com/max/1200/1*Mb3AXZaAlxC1GCGvhZ_0Cg.png');
}
.post.second:before {
  background-image: url('https://cdn-images-1.medium.com/max/1200/1*rSQdlcqd5GoT_gU8s58dZw.jpeg');
}
.post.third:before {
  background-image: url('https://cdn-images-1.medium.com/max/800/1*34PWDbS9i_ypvn0J1EwsFg.jpeg');
}
.post.fourth:before {
  background-image: url('https://cdn-images-1.medium.com/max/800/1*Fh_cqI49UjfCYHTTrsO9aA.jpeg');
}
.post.fifth:before {
  background-image: url('https://cdn-images-1.medium.com/max/800/1*nbzBv3b1oZlS2KCqyOaWRQ.jpeg');
}
.post h2 {
  position: absolute;
  width: 100%;
  bottom: 0;
  color: white;
  padding: 0.5rem 1rem;
  text-shadow: 1px 1px 2px black;
}
</style>



// WEBPACK FOOTER //
// Posts.vue?367b7ea2